import { useLocation } from 'react-router'
import { Box } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'

import { tokens } from '@configuration/theme'
import SplitAuthLayout from '@components/SplitAuthLayout/SplitAuthLayout.component'
import BackToLogin from '@components/BackToLogin/BackToLogin.component'

import { sanitiseErrorCode, sanitiseErrorId } from './OAuthErrorPage.utils'

const OAuthErrorPage = () => {
  const intl = useIntl()
  const params = new URLSearchParams(useLocation().search)
  const errorCode = sanitiseErrorCode(params.get('error'))
  const errorId = sanitiseErrorId(params.get('id'))

  return (
    <SplitAuthLayout
      heading={intl.formatMessage({ id: 'oauthError.welcome' })}
      dataTestId='oauth-error-page'
      back={<BackToLogin />}
    >
      <Box sx={{ color: tokens.businessBlack60, fontSize: 14, lineHeight: 1.4 }}>
        <FormattedMessage id='oauthError.body' />
      </Box>
      <Box sx={{ fontSize: 12, color: tokens.businessBlack60 }}>
        <FormattedMessage id='oauthError.errorLabel' values={{ code: errorCode }} />
      </Box>
      {errorId && (
        <Box sx={{ fontSize: 12, color: tokens.businessBlack60 }}>
          <FormattedMessage id='oauthError.referenceLabel' values={{ id: errorId }} />
        </Box>
      )}
    </SplitAuthLayout>
  )
}

export default OAuthErrorPage
